import BaseEntity from '../base/BaseEntity.model';
import Persona from './persona.model';
import Direccion from '../direccion.model';

export default class PersonaDireccion extends BaseEntity{
    public personaId?: number;
    public direccionId?: number;
    public persona?: Persona;
    public direccion?: Direccion;
    constructor(){
        super();
        this.init();
    }

    init(){
        this.id = undefined;
        this.personaId = undefined;
        this.direccionId = undefined;
        this.persona = undefined;
        this.direccion = undefined;
    }
}
